//import { Injectable } from "../../../node_modules/@angular/core";
//import { Constants} from './constants';

 
export class CommonFunctions {
    constructor(){}
    private s4(): string {
		return Math.floor((1 + Math.random()) * 0x10000)
			.toString(16)
			.substring(1);
  }
  
  public getnewguid(): string {
		return this.s4() + this.s4() + '-' + this.s4() + '-' + this.s4() + '-' + this.s4() + '-' + this.s4() + this.s4() + this.s4();
  }

  public currencyFormat(num) {
    //return '$' + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') // removing cents
   // return '$' + num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    
    return '$' + Math.round(num).toString()
    .replace(/\D/g, "")
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  }
  

  public formatDatetime(date: Date, format: string) {
    const _padStart = (value: number): string => value.toString().padStart(2, '0');
 return format
     .replace(/yyyy/g, _padStart(date.getFullYear()))
     .replace(/dd/g, _padStart(date.getDate()))
     .replace(/mm/g, _padStart(date.getMonth() + 1))
     .replace(/hh/g, _padStart(date.getHours()))
     .replace(/ii/g, _padStart(date.getMinutes()))
     .replace(/ss/g, _padStart(date.getSeconds()));
 }
}